import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { formatarData, formatarPlaca } from 'src/app/core/utils/utilities';
import {
  IGetRelatorioLaudosExcluidosCanceladosListParams,
  IGetRelatorioLaudosExcluidosCanceladosListResponse,
  IGetRelatorioLaudosExcluidosCanceladosItem
} from 'src/app/services/ReportService/report.model';
import { ReportService } from 'src/app/services/ReportService/report.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';

@Component({
  selector: 'app-laudos-excluidos-cancelados',
  templateUrl: './laudos-excluidos-cancelados.component.html',
  styleUrls: ['./laudos-excluidos-cancelados.component.scss']
})
export class LaudosExcluidosCanceladosComponent {
  form = this.fb.group({
    TX_PLCA_CAVA: [null as string | null],
    DT_INIC: [null as string | null],
    DT_FIM: [null as string | null]
  });

  isLoading: boolean = false;
  numeroPagina: number = 0;
  maxPages: number = 1;
  tableData: Array<any> = [];

  pesquisaParams = {
    PAGE_NUMBER: 1,
    PAGE_SIZE: 20
  };

  tableColumns = [
    { header: 'Cód. Laudo', key: 'codigoLaudo', type: 'text' },
    { header: 'Placa', key: 'placa', type: 'text' },
    { header: 'Motorista', key: 'motorista', type: 'text' },
    { header: 'Criado em', key: 'criadoEm', type: 'text' },
    { header: 'Situação', key: 'situacao', type: 'text' },
    { header: 'Excluído/Cancelado em', key: 'excluidoEm', type: 'text' },
    { header: 'Excluído/Cancelado por', key: 'excluidoPor', type: 'text' }
  ];

  constructor(
    private fb: FormBuilder,
    private reportService: ReportService,
    private appExportBase64: AppExportBase64
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.pesquisaParams.PAGE_NUMBER = 1;
      this.numeroPagina = 0;
      this.loadData();
    });
  }

  mudarPagina(pagina: number): void {
    this.pesquisaParams.PAGE_NUMBER = pagina + 1;
    this.numeroPagina = pagina;
    this.loadData();
  }

  private createPayload(): IGetRelatorioLaudosExcluidosCanceladosListParams {
    return {
      TX_PLCA_CAVA: this.form.controls.TX_PLCA_CAVA.value ?? undefined,
      DT_INIC: this.form.controls.DT_INIC.value ?? undefined,
      DT_FIM: this.form.controls.DT_FIM.value ?? undefined,
      PAGE_NUMBER: this.pesquisaParams.PAGE_NUMBER,
      PAGE_SIZE: this.pesquisaParams.PAGE_SIZE
    };
  }

  loadData(): void {
    this.isLoading = true;
    const payload = this.createPayload();

    this.reportService.GetRelatorioLaudosExcluidosCancelados(payload).subscribe({
      next: (response: IGetRelatorioLaudosExcluidosCanceladosListResponse) => {
        this.tableData = response.ITEMS.map((item: IGetRelatorioLaudosExcluidosCanceladosItem) => ({
          codigoLaudo: item.PK_LAUD_SRVC ?? '---',
          placa: formatarPlaca(item.TX_PLCA_CAVA) ?? '---',
          motorista: item.NM_MTRT ?? '---',
          criadoEm: formatarData(item.DT_CRIA) ?? '---',
          situacao: item.TX_SITUACAO ?? '---',
          excluidoEm: item.DT_EXCL ? formatarData(item.DT_EXCL) ?? '---' : '---',
          excluidoPor: item.NM_FUNC_EXCL ?? '---'
        }));
        this.maxPages = response.TOTAL_PAGES;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  exportarExcel(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.reportService.GetReportLaudosExcluidosCanceladosExcel({
      TX_PLCA_CAVA: payload.TX_PLCA_CAVA,
      DT_INIC: payload.DT_INIC,
      DT_FIM: payload.DT_FIM
    }).subscribe({
      next: response => {
        this.appExportBase64.downloadExcel(response.ReportBase64, 'Laudos Excluídos Cancelados.xlsx');
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
}
